
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retool",
      function () {
        return require("private-next-pages/retool.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retool"])
      });
    }
  